module.exports = __webpack_public_path__ + "static/face-81ba50d0bfaf810bdaaf1af27a2f03a3.jpg";